import { useMemo } from 'react';
import { useNavigate, useI18n } from '@ywwwtseng/react-kit';
import { type FormElement, Form, validator } from '../../lib/react-form';
import { useAccountVerificationForm } from '../../hooks/useAccountVerificationForm';

export default function AccountVerificationScreen({
  params,
}: {
  params: { back?: string };
}) {
  const { t } = useI18n();
  const navigate = useNavigate();
  const form = useAccountVerificationForm();

  const elements = useMemo<{ row: FormElement[] }[]>(() => {
    return [
      {
        row: [
          {
            ui: 'description',
            text: t('account_verification.description'),
          },
        ],
      },
      {
        row: [
          {
            ui: 'date',
            label: t('account_verification.birth_date'),
            name: 'birth_date',
            validate: validator.required({
              message: t('validation.required', {
                name: t('account_verification.birth_date'),
              }),
            }),
          },
        ],
      },
    ];
  }, [form.values]);

  return (
    <div className="flex flex-col justify-start w-full h-full gap-2 py-3 px-5">
      <Form
        name="account_verification"
        {...form}
        elements={elements}
        submit={{
          label: t('common.next'),
        }}
        onSubmit={() => {
          navigate('AccountVerification2', { params, type: 'replace' });
        }}
      />
    </div>
  );
}
